export const DEFAULT_SITE_DOMAIN = 'stgquiz.com';
export const DEFAULT_SITE_BASE_URL = 'https://www.stgquiz.com';

export const SITE_DOMAIN =
  process.env.NODE_ENV === 'development'
    ? 'localhost:8000'
    : process.env.GATSBY_SITE_DOMAIN || DEFAULT_SITE_DOMAIN;

export const SITE_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : process.env.GATSBY_SITE_BASE_URL || DEFAULT_SITE_BASE_URL;

export const SHARE_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'https://preview--scifi-dev-quiz-site-5redzg9w.netlify.app'
    : SITE_BASE_URL;

export const ENV = process.env.NODE_ENV || 'development';

export const ENABLED_COUNTRY_CODES = ['IN', 'US'];
export const JOIN_US_URL_BY_COUNTRY = {
  IN: 'https://career.infosys.com/joblist?companyhiringtype=IL&countrycode=IN&searchJob=Power%20Programmer',
  US: 'https://digitalcareers.infosys.com/infosys/power-programmers?Codes=PowerProgrammer',
};
